import React from 'react';
import { observer } from 'mobx-react';
import { WelcomeGiftStore } from '@gamiphy/loyalty-station-desktop/store/welcomeGift';
import ProgressCard from './components/ProgressCard';
import UnlockedCard from './components/UnlockedCard';
import LockedCard from './components/LockedCard';

const WelcomeGiftCard = observer(() => {
  if ((WelcomeGiftStore.unlocked && WelcomeGiftStore.completed) || !WelcomeGiftStore.availableToUse) {
    return null;
  }
  switch (WelcomeGiftStore.progress) {
    case undefined:
      return null;
    case 0:
      return <LockedCard />;
    case 100:
      return <UnlockedCard />;
    default:
      return <ProgressCard />;
  }
});

export default WelcomeGiftCard;
